export default __webpack_public_path__ + "static/media/img_1@2x.c8d6aa22.png";